import { Component } from 'preact'

import { ContentType } from '@insided/shared/utils/contentType'
import { IdeaStatus, Topic } from '../interfaces'
import MergeIdeaModal from './MergeIdeaModal'

/* eslint-disable import/no-internal-modules */
import ButtonControl from '@insided/deprecated-preact-components/button-control'

export interface MergeIdeaProps {
  fromIdea: Topic
  ideaStatus: IdeaStatus
  ideaStatuses: IdeaStatus[]
  contentType: ContentType
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

export interface MergeIdeaState {
  showMergeIdeaModal: boolean
}

class MergeIdea extends Component<MergeIdeaProps, MergeIdeaState> {
  constructor() {
    super()
    this.setState({
      showMergeIdeaModal: false
    })
    this.showMergeIdeaModal = this.showMergeIdeaModal.bind(this)
    this.hideMergeIdeaModal = this.hideMergeIdeaModal.bind(this)
  }

  showMergeIdeaModal() {
    this.setState({ showMergeIdeaModal: true })
  }

  hideMergeIdeaModal() {
    this.setState({ showMergeIdeaModal: false })
  }

  render() {
    const { fromIdea, ideaStatus, ideaStatuses, contentType, onShowAlert } = this.props
    const { showMergeIdeaModal } = this.state
    return (
      <div>
        <ButtonControl title='Merge idea' onClick={this.showMergeIdeaModal} />
        {showMergeIdeaModal &&
          <MergeIdeaModal
            contentType={contentType}
            fromIdea={fromIdea}
            fromIdeaStatus={ideaStatus}
            ideaStatuses={ideaStatuses}
            isOpen={showMergeIdeaModal}
            onClose={this.hideMergeIdeaModal}
            onShowAlert={onShowAlert}
          />}
      </div>
    )
  }
}

export default MergeIdea
